import {
  useNavigate,
  Link,
  Routes,
  Route,
  createSearchParams,
  useSearchParams,
  useParams,
} from 'react-router-dom'
import { RouterContext } from 'shared/router'

export const RouterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate()

  return (
    <RouterContext.Provider
      value={{
        Link,
        navigate,
        Routes,
        Route,
        createSearchParams,
        useSearchParams,
        useParams,
      }}
    >
      {children}
    </RouterContext.Provider>
  )
}
